if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const productLink =
          window.shopUrl +
          opener.getAttribute('data-product-url') +
          '?view=modal';

        fetch(productLink)
          .then((response) => response.text())
          .then((responseText) => {
            // Parse and inject the modal HTML
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-Quickview-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            this.hideVariantAantal();

            // Re-init Shopify buttons & 3D models
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            // Show the modal
            super.show(opener);

            // After 500ms, try to auto-select the second variant
            
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        // Reinject script tags so they execute
        element.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value)
          );
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          'variant-selects'
        );
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        // Remove elements we don't need in the quick-add
        this.productElement
          .querySelectorAll('pickup-availability, product-modal, modal-dialog')
          .forEach((el) => el.remove());
        
        // Hide variant-aantal selector in quick-add
        this.productElement
          .querySelectorAll('.variant-aantal, .variant-anzahl, .variant-quantity')
          .forEach((el) => el.style.display = 'none');
      }

      hideVariantAantal() {
        // Hide variant-aantal selector in the modal content
        // Try both regular DOM and shadow DOM queries
        const variantPicker = this.modalContent.querySelector('variant-selects');
        
        if (variantPicker) {
          const container = variantPicker.shadowRoot || variantPicker;
          container
            .querySelectorAll('.variant-aantal, .variant-anzahl, .variant-quantity')
            .forEach((el) => {
              el.style.display = 'none';
              el.classList.add('hidden');
            });
        }
        
        // Also try direct query from modalContent as fallback
        this.modalContent
          .querySelectorAll('.variant-aantal, .variant-anzahl, .variant-quantity')
          .forEach((el) => {
            el.style.display = 'none';
            el.classList.add('hidden');
          });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((el) => {
          el.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product?.classList.contains('product--columns')) return;
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes =
          '(min-width: 1000px) 715px, (min-width: 767px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          sizes = sizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          sizes = sizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', sizes));
      }
    }
  );
}
